module.exports = __webpack_public_path__ + "img/f4dfa041d8a75c8d0eaab95854b6a260.png";